import { Modal } from 'react-bootstrap';

const moneyFmt = (v) => {
    const n = Number(v || 0);
    return new Intl.NumberFormat('es-MX', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(Number.isNaN(n) ? 0 : n);
};

/* Tolerancia para redondeos de punto flotante al comparar monto capturado vs total calculado */
const TOLERANCIA = 0.01;

const ConfirmarGuardarFacturaModal = ({ show, onHide, onConfirm, monto, totalCalculado, prefMoneda, loading, titulo }) => {
    const diferencia = Number(monto || 0) - Number(totalCalculado || 0);
    const coincide = Math.abs(diferencia) <= TOLERANCIA;

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{titulo || 'Confirmar factura'}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="mb-3">
                    <div className="d-flex justify-content-between py-1">
                        <span className="text-muted">Monto capturado</span>
                        <span className="fw-semibold">{prefMoneda} {moneyFmt(monto)}</span>
                    </div>
                    <div className="d-flex justify-content-between py-1">
                        <span className="text-muted">Total calculado de productos</span>
                        <span className="fw-semibold">{prefMoneda} {moneyFmt(totalCalculado)}</span>
                    </div>
                    <hr className="my-2" />
                    <div className="d-flex justify-content-between py-1">
                        <span className="text-muted">Diferencia</span>
                        <span className={`fw-bold ${coincide ? 'text-success' : 'text-danger'}`}>
                            {prefMoneda} {moneyFmt(Math.abs(diferencia))}
                        </span>
                    </div>
                </div>

                {coincide ? (
                    <div className="alert alert-success mb-0" style={{ fontSize: 13 }}>
                        El monto capturado coincide con el total calculado de los productos.
                    </div>
                ) : (
                    <div className="alert alert-warning mb-0" style={{ fontSize: 13 }}>
                        El monto capturado <b>no coincide</b> con el total calculado de los productos. Verifica antes de continuar.
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <button type="button" className="btn btn-secondary" onClick={onHide} disabled={loading}>
                    Cancelar
                </button>
                <button type="button" className="btn btn-success" onClick={onConfirm} disabled={loading}>
                    {loading ? 'Guardando...' : 'Confirmar y guardar'}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmarGuardarFacturaModal;
